<template>
    <UiSelect
        :model-value="modelValue"
        :options="seasonOptions"
        label="Сезон"
        :multiple="multiple"
        :disabled="disabled"
        :min-selected="multiple ? 1 : 0"
        :value-type="valueType"
        :block="block"
        :align="align"
        placeholder="Выберите сезон"
        :summary-fn="formatSummary"
        @change="onChange"
    />
</template>

<script setup>
import { computed } from 'vue';
import UiSelect from '@/components/ui/forms/UiSelect.vue';

const props = defineProps({
    seasons: { type: Array, default: () => [] },
    modelValue: { type: [Array, Number, String], default: null },
    multiple: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    includeAll: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    align: { type: String, default: 'right' },
});

const emit = defineEmits(['update:modelValue', 'change']);

const valueType = computed(() => (props.includeAll ? 'string' : 'number'));

const seasonOptions = computed(() => {
    const options = props.seasons.map((season) => ({
        value: props.includeAll ? String(season.id) : season.id,
        label: season.name,
    }));

    if (props.includeAll) {
        return [{ value: 'all', label: 'Все' }, ...options];
    }

    return options;
});

function formatSummary(ids, options) {
    if (!ids.length) {
        return props.includeAll ? 'Все' : 'Выберите сезон';
    }

    if (ids.length === 1) {
        if (ids[0] === 'all') {
            return 'Все';
        }
        const option = options.find((item) => String(item.value) === String(ids[0]));
        return option?.label || (props.includeAll ? 'Сезон' : '1 сезон');
    }

    const names = options
        .filter((item) => ids.some((id) => String(item.value) === String(id)))
        .map((item) => item.label);

    if (names.length <= 2) {
        return names.join(', ');
    }

    return `${ids.length} сезона`;
}

function onChange(value) {
    emit('update:modelValue', value);
    emit('change', value);
}
</script>
